import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { PagingComponent } from './paging.component';
import { SortPropertyDirective } from './sort.property.directive';

@NgModule({
    declarations: [PagingComponent, SortPropertyDirective],
    imports: [BrowserModule],
    exports: [PagingComponent, SortPropertyDirective]
})

export class PagingModule {}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/search/paging.module.ts